import { BasicAPI } from '../../core-apis/src/apis/config/api/basicApi'
import { BasicXLegacyTokenAPI } from '../../core-apis/src/apis/config/api/basicXLegacyTokenApi'
import { BearerTokenApi } from '../../core-apis/src/apis/config/api/bearerTokenApi'
import { AuthenticatedAPI } from '../../core-apis/src/apis/config/api/authenticatedApi'
import { BasicXAPI } from '../../core-apis/src/apis/config/api/basicXApi'

const baseApiUrl = process.env.WIGGOT_API ?? ''

class DefaultApi extends AuthenticatedAPI {
  constructor() {
    super({
      domain: baseApiUrl
    })
  }
}

class DefaultApiBasic extends BasicAPI {
  constructor() {
    super({
      domain: baseApiUrl
    })
  }
}

class DefaultApiBasicX extends BasicXAPI {
  constructor() {
    super({
      domain: baseApiUrl
    })
  }
}

class DefaultApiBasicXLegacyToken extends BasicXLegacyTokenAPI {
  constructor() {
    super({
      domain: baseApiUrl
    })
  }
}
class DefaultApiBearerToken extends BearerTokenApi {
  constructor() {
    super({
      domain: baseApiUrl
    })
  }
}

export const defaultApiBasic = new DefaultApiBasic()
export const defaultApi = new DefaultApi()
export const defaultApiBasicX = new DefaultApiBasicX()
export const defaultApiBasicXLegacyToken = new DefaultApiBasicXLegacyToken()
export const defaultApiBearerToken = new DefaultApiBearerToken()
